import type { BreakpointSize } from "@/types/UITypes";

export const SM_BREAKPOINT = 490; // 30.625rem
export const MD_BREAKPOINT = 768; // 48rem
export const LG_BREAKPOINT = 1040; // 65rem
export const XL_BREAKPOINT = 1440; // 90rem

export const BREAKPOINTS: Record<BreakpointSize, number> = {
    sm: SM_BREAKPOINT,
    md: MD_BREAKPOINT,
    lg: LG_BREAKPOINT,
    xl: XL_BREAKPOINT,
} as const;
